import React, { useEffect, useState } from "react";
import { Offcanvas, OffcanvasBody, OffcanvasHeader,  Badge,
 } from "reactstrap";
import AppointmentService from "../../../services/KangarooServices/AppointmentService";

const AppointmentDetail = ({ isOpen, toggle, selectedEvent }) => {
  const [detailData, setDetailData] = useState(null);

  const appointmentId = selectedEvent?.agents?.[0]?.appointmentId;

  const fetchDetail = async () => {
    if (!appointmentId) return;
    try {
      const response = await AppointmentService.getDetail(appointmentId);
      setDetailData(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [appointmentId]);

  if (!detailData) {
    return (
      <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
        <OffcanvasHeader toggle={toggle}>Appointment Detail</OffcanvasHeader>
        <OffcanvasBody>Loading...</OffcanvasBody>
      </Offcanvas>
    );
  }

  const {
    date,
    startTime,
    endTime,
    agentName,
    customerName,
    customerPhone,
    studentInterestForm,
  } = detailData;

  return (
    <Offcanvas isOpen={isOpen} toggle={toggle} direction="end">
      <OffcanvasHeader toggle={toggle}>
        Appointment Detail
      </OffcanvasHeader>

      <OffcanvasBody>
        {/* CUSTOMER INFO */}
        <div className="border rounded p-3 mb-3">
          <h6 className="mb-2">
            <i className="bx bx-user me-2" />
            Customer
          </h6>

          <p className="mb-1">
            <strong>Name:</strong> {customerName}
          </p>

          <p className="mb-1">
            <i className="bx bx-phone me-1" />
            {customerPhone}
          </p>

          <Badge color="info">
            <i className="bx bx-user-check me-1" />
            {studentInterestForm?.status}
          </Badge>
        </div>

        {/* APPOINTMENT INFO */}
        <div className="border rounded p-3 mb-3">
          <h6 className="mb-2">
            <i className="bx bx-calendar me-2" />
            Appointment
          </h6>

          <p className="mb-1">
            <i className="bx bx-calendar-event me-1" />
            {new Date(date).toLocaleDateString()}
          </p>

          <p className="mb-1">
            <i className="bx bx-time-five me-1" />
            {startTime} - {endTime}
          </p>

          <Badge color="success">
            <i className="bx bx-briefcase-alt me-1" />
            {studentInterestForm?.serviceName}
          </Badge>
        </div>

        {/* AGENT INFO */}
        <div className="border rounded p-3 mb-3">
          <h6 className="mb-2">
            <i className="bx bx-id-card me-2" />
            Agent
          </h6>

          <p className="mb-0">{agentName}</p>
        </div>

        {/* BRANCH & MESSAGE */}
        <div className="border rounded p-3">
          <h6 className="mb-2">
            <i className="bx bx-buildings me-2" />
            Branch
          </h6>

          <Badge color="primary" className="mb-2">
            {studentInterestForm?.preferedBranchName}
          </Badge>

          {studentInterestForm?.message && (
            <>
              <hr />
              <p className="mb-0">
                <i className="bx bx-message-dots me-1" />
                {studentInterestForm.message}
              </p>
            </>
          )}
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default AppointmentDetail;